<login-view-layout [template]="loginViewTpl"></login-view-layout>

<ng-template #loginViewTpl
             let-content>
    <login-form-content [content]="content"></login-form-content>
</ng-template>